import { render, staticRenderFns } from "./visit_service_order_page.vue?vue&type=template&id=b1bfc196&scoped=true"
import script from "./visit_service_order_page.vue?vue&type=script&lang=js"
export * from "./visit_service_order_page.vue?vue&type=script&lang=js"
import style0 from "./visit_service_order_page.vue?vue&type=style&index=0&id=b1bfc196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bfc196",
  null
  
)

export default component.exports